/*
  Sher Organics - article template behaviour (T13)
  Vanilla JS, no libraries.

  - Reading progress bar, driven by scroll position. Disabled under
    prefers-reduced-motion (PRD Section 7).
  - Table of contents generated FROM the rendered H2 headings, with anchor IDs
    derived from each heading's text. It is not hardcoded, so it works for every
    article the client writes. The active heading is highlighted on scroll.
  - Copy-link share control using the Clipboard API.

  If the article body has no H2 headings, the TOC block removes itself, so a
  short post does not show an empty sidebar.
*/
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* text -> slug for anchor IDs, mirroring Shopify's handleize */
  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .replace(/['".,/#!$%^&*;:{}=_`~()]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
    var slug = base;
    var n = 2;
    while (used[slug]) {
      slug = base + '-' + n;
      n += 1;
    }
    used[slug] = true;
    return slug;
  }

  function initProgress() {
    var bar = document.querySelector('.reading-progress');
    if (!bar) return;
    /* Under reduced motion the bar is hidden entirely rather than animated. */
    if (reduce) {
      bar.remove();
      return;
    }
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }
    update();
    window.addEventListener('scroll', function () {
      requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
  }

  function initToc() {
    var toc = document.querySelector('.toc');
    var nav = document.getElementById('tocNav');
    var content = document.querySelector('.article-template__content');
    if (!toc || !nav || !content) return;

    var heads = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (heads.length === 0) {
      /* No headings to link to: drop only the TOC heading and nav, NOT the
         whole sidebar, so the share block (which shares the sidebar) survives.
         If the share block is absent too, the empty sidebar is removed. */
      var heading = toc.querySelector('.toc__heading');
      if (heading) heading.remove();
      nav.remove();
      if (!toc.querySelector('.share')) toc.remove();
      return;
    }

    var used = {};
    heads.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);
      else used[h.id] = true;
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      nav.appendChild(a);
    });

    var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
    function spy() {
      var pos = window.scrollY + 140;
      var cur = heads[0];
      heads.forEach(function (h) {
        if (h.offsetTop <= pos) cur = h;
      });
      links.forEach(function (a) {
        a.classList.toggle('on', a.getAttribute('href') === '#' + cur.id);
      });
    }
    spy();
    window.addEventListener('scroll', function () {
      requestAnimationFrame(spy);
    }, { passive: true });
  }

  function initShare() {
    var copyBtn = document.querySelector('[data-copy-link]');
    if (!copyBtn) return;
    copyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = copyBtn.getAttribute('data-url') || window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          copyBtn.classList.add('copied');
          setTimeout(function () { copyBtn.classList.remove('copied'); }, 1600);
        });
      }
    });
  }

  function init() {
    initProgress();
    initToc();
    initShare();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
